import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .MEVFilterAndListCointiner': {
    position: 'relative',
    paddingTop: theme.typography.pxToRem(112),
    [theme.breakpoints.down('lg')]: {
      paddingTop: theme.typography.pxToRem(40),
    },
 '& .MEVBGPattern': {
      position: 'absolute',
      top: 0,
      width: '100%',
      height: theme.typography.pxToRem(205),
      zIndex: 1,
     filter: 'brightness(0.7) contrast(2)',
    },
  },
}));

export default StyledBox;
